module.exports = __webpack_public_path__ + "img/wmtx.4007c159.png";